 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		61: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"2":"pages/deal/accommodation/_slug/pages/deal/amadeus-package-tour/_slug/pages/deal/basic/_slug/pages/de/af768e46","3":"pages/deal/accommodation/_slug/pages/deal/amadeus-package-tour/_slug/pages/deal/basic/_slug/pages/de/8c4c27cf","21":"commons/pages/preferences/center","22":"pages/404/index","23":"pages/auth/activate","24":"pages/auth/forgot-password","25":"pages/auth/login","26":"pages/auth/logout","27":"pages/auth/participation-confirmation-raffle","28":"pages/auth/register","29":"pages/auth/reset-password","30":"pages/bookmarks","31":"pages/deal/accommodation/_slug","32":"pages/deal/amadeus-package-tour/_slug","33":"pages/deal/basic/_slug","34":"pages/deal/flight/_slug","35":"pages/deal/package-tour/_slug","36":"pages/deal/travel-basic/_slug","37":"pages/deal/travel-combination/_slug","38":"pages/deals","39":"pages/gutscheinauszahlung/index","40":"pages/hotd","41":"pages/index","42":"pages/kortinguitbetaling/index","43":"pages/newsletter/index","44":"pages/partner/ameropa/amsterdam-deal","45":"pages/partner/ameropa/berlin-deal","46":"pages/partner/ameropa/berlin-deal-2","47":"pages/partner/ameropa/dresden-deal","48":"pages/partner/ameropa/dresden-deal-2","49":"pages/partner/ameropa/hamburg-deal","50":"pages/partner/ameropa/hamburg-deal-2","51":"pages/partner/ameropa/index","52":"pages/partner/ameropa/koeln-deal","53":"pages/partner/ameropa/leipzig-deal","54":"pages/partner/ameropa/muenchen-deal","55":"pages/partner/ameropa/muenchen-deal-2","56":"pages/partners","57":"pages/preferences/center","58":"pages/preferences/index","59":"pages/reise-agent/index","60":"pages/tag/_slug","63":"vendors/pages/index"}[chunkId]||chunkId) + "." + {"0":"cfc7264","1":"5bc327d","2":"5578e18","3":"a21a881","4":"1991f8b","5":"59c46c0","6":"b9316bc","7":"483826c","8":"f41dc7c","9":"579f438","10":"53d4514","11":"a8b07fd","12":"2acd7f6","13":"b0cc0e8","14":"f264e36","15":"05086d2","16":"e8428ef","17":"d853bab","18":"4b102cc","21":"07504b5","22":"3b28b02","23":"5746d64","24":"b9c7041","25":"fe26d29","26":"01291ce","27":"2a83905","28":"22a2e3f","29":"771dc9b","30":"471718d","31":"82ef309","32":"e9d5230","33":"b6cd655","34":"f507d21","35":"dfebe39","36":"23f819c","37":"df30732","38":"9214919","39":"f704abf","40":"568e9e9","41":"50673bc","42":"f89d621","43":"6b4516e","44":"8d9ee48","45":"6e0cc86","46":"b689c73","47":"9fd662a","48":"03aed07","49":"eb7555c","50":"9379c48","51":"f8a0a99","52":"88af8c9","53":"38828c3","54":"080be61","55":"66135f5","56":"855d8dc","57":"c08da07","58":"d55cc34","59":"cf85f00","60":"36e9f9a","63":"2b0d3c8","64":"0dce9c2","65":"3564a9b","66":"9d177ad","67":"10aff37","68":"47c714e","69":"c865264","70":"a74c7a3","71":"0f9da02","72":"29076cf","73":"d6f1fc6","74":"bda9e31","75":"786a0eb","76":"ffc36c7","77":"08a8a48","78":"923ae50","79":"d65f077","80":"840d5a5","81":"43fe04f","82":"701a341","83":"56216df","84":"7db0cbc","85":"7de7128","86":"5c10041","87":"5a0dc56","88":"806c2f0","89":"34c210d","90":"cff8378","91":"c810616","92":"986c0ff","93":"85dcd38","94":"43c79c9","95":"0288664","96":"fa8069e","97":"3ae8bcc","98":"9335102","99":"904243c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/_nuxt/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
